import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HttpService } from '../../../../core';
import { ToastrService } from 'ngx-toastr';
import { ProjectService } from '../../../../core/services/project.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-delete-dialog',
  templateUrl: './delete-dialog.component.html',
  styleUrls: ['./delete-dialog.component.scss']
})

export class DeleteDialogComponent implements OnInit {

  projectId: any;

  constructor(
    private dialogRef: MatDialogRef<any>,
    private httpService: HttpService,
    private router: Router,
    private projectService: ProjectService,
    private toastrService: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngOnInit(): void {
    console.log(this.data);
    if (!this.data.isPackage) {
      this.projectId = this.data.projectId;
    } else {
      this.projectId = this.data.packageProject.id;
    }
    // this.httpService.getAllFloorPlansByProjectId(this.projectId).subscribe((res: any) => {
    //   console.log(res);
    //
    // });
  }


  cancel() {
    this.dialogRef.close();
  }

  deleteProject() {
    this.httpService.deleteProject(this.projectId).subscribe((res: any) => {
      console.log(res);
      if (res.code === 1) {
        this.projectService.projects = null;
        if (!this.data.isPackage) {
          this.router.navigateByUrl('/projects');
          this.toastrService.success('The project has been deleted.');
        } else {
          this.dialogRef.close('success');
          // this.router.navigateByUrl('/projects/' + this.data.parentProjectId + '/edit');
          this.toastrService.success('The H&L package has been deleted.');

        }
      } else if (res.code === -12) {
        this.toastrService.error('project has associated items');
        this.dialogRef.close();
      } else {
        this.dialogRef.close();
        this.toastrService.error(this.data.isPackage ? 'Failed to delete the H&L package.' : 'Failed to delete this project.');
      }
    });

  }

}
